<template>
  <div>
    <Modal
      ref="modal"
      title="Delete job city"
      body="Are you sure you want to delete this city? This action can be reversed by adding the city again later."
      action="Delete"
      action-color="red"
      @close-modal="handleCancel"
      @handle-action="handleDeactivate"
    />
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import { deactivateJobLocation } from '../../api/jobs';

export default {
  name: 'JobCityDelete',
  components: {
    Modal,
  },
  props: {
    jobLocationId: {
      type: [Number, String],
      required: true,
    },
    v2JobId: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    async handleDeactivate() {
      if (!this.validateIds()) {
        return;
      }

      try {
        await deactivateJobLocation({
          jobId: this.v2JobId,
          locationId: this.jobLocationId,
        });

        this.handleSuccess();
      } catch (error) {
        this.handleError(error);
      }
    },

    validateIds() {
      if (!this.jobLocationId || !this.v2JobId) {
        console.error('Missing required IDs:', { jobLocationId: this.jobLocationId, v2JobId: this.v2JobId });
        return false;
      }
      return true;
    },

    handleSuccess() {
      if (this.$refs.modal && typeof this.$refs.modal.success === 'function') {
        this.$refs.modal.success();
      } else {
        this.$store.commit('general/hideLocalLoadingSpinner');
      }

      this.$emit('handleJobCityDelete');
      this.$store.commit('general/showAlert', {
        alertType: 'success',
        alertTitle: 'City deleted',
        alertDescription: 'The city was successfully deleted. You can add it back later if needed.',
      });
    },

    handleError(error) {
      console.error('Failed to delete job location:', error);
      this.$store.commit('general/showAlert', {
        alertType: 'error',
        alertTitle: 'Failed to delete city',
        alertDescription: 'There was an error deleting the city. Please try again.',
      });
    },

    handleCancel() {
      this.$emit('handleJobCityDeleteCancel');
    },
  },
};
</script>
